<template>
  <ion-page>
    <ion-content class="ion-padding-top bg-grad-content">
      <div class="ion-text-start ion-padding product-info" v-if="product">
        <h3 class="ion-padding-top">{{ product.nombre }}</h3>
        <p>
          {{ `${mdmoto.descripcion} - ${mdmoto.marcamoto.data.descripcion}` }}
        </p>
        <p>
          {{ product.descripcion }}
        </p>
        <ion-text color="secondary">
          <h3>{{ $filters.currencyFormat(product.precio) }}</h3>
        </ion-text>
      </div>
      <ion-slides
        v-if="product"
        pager="false"
        :options="slideOpts"
        ref="prodDetailSlide"
        class="ion-slides-prod-detail"
        @click="sliderClicked($event)"
      >
        <ion-slide
          v-for="(prod, index) in product.imageprod.data"
          :key="index"
          style="border-radius: 10px;"
        >
          <img v-lazy="prod.imagen" style="border-radius: 10px;" />
        </ion-slide>
      </ion-slides>
    </ion-content>
    <ion-footer class="footer-product-detail">
      <ion-row>
        <ion-col class="ion-text-center" @click="addProductToCart(product)">
          <i class="mdi mdi-cart-plus mdi-36px"></i>
        </ion-col>
        <ion-col class="ion-text-center" @click="likeProduct(product)">
          <i class="mdi mdi-briefcase-check-outline mdi-36px"></i>
        </ion-col>
        <ion-col
          class="ion-text-center"
          @click="
            goWhatsApp(
              `Hola, quiero información sobre: ${mdmoto.descripcion} - ${mdmoto.marcamoto.data.descripcion}, ${product.nombre}`
            )
          "
          ><i class="mdi mdi-whatsapp mdi-36px color-green"></i>
        </ion-col>
        <ion-col
          class="ion-text-center"
          @click="!loadDataFromPL ? $emitter.emit('open-fpl') : null"
        >
          <i
            class="mdi mdi-36px"
            :class="
              !loadDataFromPL ? 'mdi-shopping' : 'mdi-timer-sand mdi-spin'
            "
          ></i>
        </ion-col>
      </ion-row>
    </ion-footer>
  </ion-page>
</template>

<script>
import effect from '@/tools/slide_effect'
import { __ } from '@/plugins/tools/lodash'

let plEffect = __.cloneDeep(effect.coverflowEffect)
plEffect.loop = false
export default {
  components: {},
  data(vm) {
    return {
      slideOpts: plEffect,
      loadDataFromPL: false,
      routeParams: {
        motobrand: '',
        motomodel: '',
        product_id: ''
      },
      product: null,
      mdmoto: null
    }
  },
  ionViewDidEnter() {
    this.$store.dispatch('app/keepPageState', false)
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      this.$emitter.emit('full-loader', { open: true })
      this.routeParams = this.$route.params
      this.getIndexData()
    }
  },
  ionViewWillLeave() {},
  created() {},
  beforeUnmount() {},
  mounted() {},
  computed: {
    swiper() {
      return this.$refs.prodDetailSlide.$el.swiper
    }
  },
  methods: {
    goWhatsApp(text) {
      window.open(`https://wa.me/573213813097?text=${text}`, '_blank')
    },
    addProductToCart(product) {
      product.slug = `/${this.mdmoto.marcamoto.data.descripcion_hide}/${this.mdmoto.descripcion_hide}/${this.mdmoto.id}/${product.id}`
      product.main_image = product.mainimage.data.imagen
      product.ref = `${this.mdmoto.marcamoto.data.descripcion} - ${this.mdmoto.descripcion}`
      this.$store.dispatch('cart/addProductToCart', product)
      this.$emitter.emit('toast', {
        message: 'Producto agregado al carro',
        color: 'primary'
      })
    },
    likeProduct(item) {
      let product = {
        id: item.id,
        name: item.nombre,
        image: item.mainimage.data.imagen,
        price: item.precio,
        ref: `${this.mdmoto.marcamoto.data.descripcion} - ${this.mdmoto.descripcion}`,
        slug: `/${this.mdmoto.marcamoto.data.descripcion_hide}/${this.mdmoto.descripcion_hide}/${this.mdmoto.id}/${item.id}`,
        quantity: 1
      }
      this.$emitter.emit('message-form', {
        title: 'Quiero Comprar',
        product: product,
        mdmoto: this.mdmoto
      })
    },
    sliderClicked(event) {
      if (
        !event.target.classList.contains('swiper-pagination-bullet') &&
        !event.target.classList.contains('swiper-button-next') &&
        !event.target.classList.contains('swiper-button-prev')
      ) {
        let image = this.product.imageprod.data[this.swiper.realIndex].imagen
        this.zoomImage(image)
      }
    },
    async zoomImage(image) {
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/imageToView', image)
      this.$router.push({ name: 'view-image' })
    },
    getIndexData() {
      let data = this.routeParams
      this.$http
        .get('app-mobile/product-detail', { params: data })
        .then((res) => {
          this.product = res.data.product.data
          this.mdmoto = res.data.mdmoto.data
          this.$emitter.emit('full-loader', { open: false })
        })
        .catch((err) => {})
    }
  }
}
</script>

<style>
.footer-product-detail {
  background: rgba(0, 0, 0, 0.8);
  color: white;
}

.ion-slides-prod-detail {
  height: 300px;
}
.product-info .list-ios {
  background: transparent;
}
.product-info .list-md {
  background: transparent;
}
.product-info .item-native {
  background: transparent;
}

.product-info ion-item {
  --background: transparent;
  --border-color: transparent;
}
</style>
